import React, { useState } from "react";
import assetsRoute from "../../../../utilities/assetsRoute";

const Diagnostico = (props) => {
  const route = `/wp-content/themes/observatorio-omt-web/assets/flags/`;
  const {
    title,
    content,
    date,
    documento,
    documentPublic,
    categories,
    materia,
    privado,
  } = props.data;
  const token = localStorage.getItem("token");
  const fecha = new Date(date);
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  const fechaFormateada = fecha.toLocaleDateString("es-ES", options);
  const [isHover, setIsHover] = useState(false);
  const [tooltipOpacity, setTooltipOpacity] = useState(0);

  return (
    <div className="data-search">
      <div className="first-section">
        <h4>{title}</h4>
        <span>{fechaFormateada}</span>
      </div>
      <div
        className="info-data"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
      <div className="second-section">
        <div className="section-tags">
          <div className="section-materia">
            {materia.map((element) => {
              return (
                <div className="text">
                  <p className="materia-txt">{element.name}</p>
                </div>
              );
            })}
          </div>
          <div className="section-country">
            {categories.map((element) => {
              if (element.iso !== null) {
                return (
                  <div className="item-flag">
                    <img
                      src={assetsRoute(
                        element.iso.toLowerCase(),
                        "flags",
                        ".svg"
                      )}
                      alt="flag"
                      className="flag-country"
                    />
                    <span className="name-country">{element.name}</span>
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="section-download">
          <div className="download-section">
            <div
              className="content-tooltip"
              style={{
                opacity: tooltipOpacity,
                transition: "opacity 0.3s ease-out",
              }}
            >
              {!privado && token === null ? (
                <span>
                  Para ver o descargar este documento, debes iniciar sesión.
                </span>
              ) : (
                <span>No tienes permisos para ver este documento</span>
              )}
            </div>
            {!privado && documentPublic === false && (
              <img
                className="icon-lock"
                src="http://localhost/sinapsis/onu-wordpress/wp-content/uploads/2023/10/Lock.svg"
                alt=""
                onMouseEnter={() => {
                  setIsHover(true);
                  setTooltipOpacity(1);
                }}
                onMouseLeave={() => {
                  setIsHover(false);
                  setTooltipOpacity(0);
                }}
              />
            )}
            {!privado && documentPublic === false ? (
              <button className="btn-download" type="button" disabled>
                Descargar
              </button>
            ) : (
              <a href={documentPublic ? documentPublic : documento} download>
                <button className="btn-download" type="button">
                  Descargar
                </button>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Diagnostico;
